import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./routes/AppRouter";
import { AuthProvider } from "react-auth-kit";
import AuthWrapper from "./components/Common/AuthWrapper";
import FloatingAlerts from "./components/Common/FloatingAlerts";

import "../node_modules/bootstrap/scss/bootstrap.scss";
import "remixicon/fonts/remixicon.css";
import 'react-accessible-accordion/dist/fancy-example.css';

// Global Style
import '../src/assets/css/style.css';
// Global responsive Style
import '../src/assets/css/responsive.css';
// Global RTL Style
import '../src/assets/css/rtl.css';

ReactDOM.render(
  <AuthProvider
    authType={"cookie"}
    authName={"_auth"}
    cookieDomain={window.location.hostname}
    cookieSecure={false}
  >
    <BrowserRouter forceRefresh={true}>
      <AuthWrapper>
        <AppRouter />
        <FloatingAlerts />
      </AuthWrapper>
    </BrowserRouter>
  </AuthProvider>,
  document.querySelector("#root")
);
